import { Badge, Nav, Navbar, NavItem, Overlay, Tooltip } from 'react-bootstrap'
import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { isTabletOrMobileQuery, isTabletOrSmallDesktopQuery } from '../../utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Moment from 'react-moment'
import moment from 'moment'
import { useMediaQuery } from 'react-responsive'
import NavBadges from './NavBadges'

const MainNavbar = () => {
  const { data: institution, loaded: institutionLoaded } = useSelector(
    (state: RootState) => state.institution,
  )
  const { data: program, loaded: programLoaded } = useSelector(
    (state: RootState) => state.program,
  )

  const { baseUrl } = useSelector((state: RootState) => state.misc)

  const dateFormatted = (
    <Moment format='DD.MM.Y'>{program.last_registration_date}</Moment>
  )

  const isTabletOrMobile = useMediaQuery(isTabletOrMobileQuery)
  const isTabletOrSmallDesktop = useMediaQuery(isTabletOrSmallDesktopQuery)
  const [open, setOpen] = useState(false)

  const dateExpired = moment().diff(program.last_registration_date, 'day')

  const target = useRef<any>(null)
  const [show, setShow] = useState(false)

  if (isTabletOrMobile) {
    return (
      <>
        <Navbar
          collapseOnSelect
          bg='primary'
          expand='xl'
          variant='dark'
          aria-label='Oberer Navigationsbalken'
        >
          <Navbar.Brand
            href='#main-content'
            onMouseOver={() => setShow(!show)}
            aria-label='Leitet Sie zu dem einzigartigen Inhalt dieser Seite'
          >
            <div ref={target}>
              <FontAwesomeIcon icon='chevron-down' role='presentation' />
            </div>
            <Overlay target={target.current} show={show} placement='bottom'>
              {(props: any) => (
                <Tooltip {...props}>
                  Leitet Sie zu dem einzigartigen Inhalt dieser Seite
                </Tooltip>
              )}
            </Overlay>
          </Navbar.Brand>
          <Navbar.Brand href={baseUrl} aria-label='Zurück zur Startseite'>
            <FontAwesomeIcon icon='home' role='presentation' />{' '}
            {programLoaded ? program.name : '?'}
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls='responsive-navbar-nav'
            aria-expanded={open}
            onClick={() => setOpen(!open)}
            label='Navigation ein -/ausblenden'
          />
          <Navbar.Collapse id='responsive-navbar-nav navbar-toggleable-lg'>
            <Nav className='ml-auto'>
              <Nav.Link
                href={`${baseUrl}/hilfe`}
                className='text-white'
              >
                <FontAwesomeIcon icon='question-circle' role='presentation' />{' '}
                Hilfe
              </Nav.Link>
              {
                institution.show_pass_resend_form && (
                  <Nav.Link
                    href={`${baseUrl}/programm/veranstaltungspass`}
                    className="text-white"
                  >
                    <FontAwesomeIcon icon="address-card" role="presentation" />{' '}
                    Veranstaltungspass verloren?
                  </Nav.Link>
                )
              }
              <Nav.Link href={`${baseUrl}/admin/`} className='text-white'>
                <FontAwesomeIcon icon='sign-in-alt' role='presentation' />{' '}
                Verwaltung
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <Navbar expand='xl' variant='light' bg='primary'>
          <Nav className='flex-column w-100 align-items-center'>
            <NavItem className='w-100 mb-2'>
              <Badge pill variant='secondary' className='d-block'>
                {program.distribution_type === 'INSTANT'
                  ? 'Sofortbuchung'
                  : 'Anmeldung mit Zuteilung'}
              </Badge>
            </NavItem>
            <NavItem className='w-100'>
              {dateExpired > 0 ? (
                <Badge pill variant='warning' className='d-block'>
                  <>Anmeldeschluss war am {dateFormatted}</>
                </Badge>
              ) : (
                <Badge pill variant='success' className='d-block'>
                  <>Anmeldeschluss ist am {dateFormatted}</>
                </Badge>
              )}
            </NavItem>
          </Nav>
        </Navbar>
      </>
    )
  } else {
    return (
      <>
        <Navbar
          collapseOnSelect
          bg='primary'
          expand='xl'
          variant='dark'
          aria-label='Oberer Navigationsbalken'
          role='status'
        >
          <Navbar.Brand
            href='#main-content'
            onMouseOver={() => setShow(!show)}
            aria-label='Leitet Sie zu dem einzigartigen Inhalt dieser Seite'
          >
            <div ref={target}>
              <FontAwesomeIcon icon='chevron-down' role='presentation' />
            </div>
            <Overlay target={target.current} show={show} placement='bottom'>
              {(props: any) => (
                <Tooltip {...props}>
                  Leitet Sie zu dem einzigartigen Inhalt dieser Seite
                </Tooltip>
              )}
            </Overlay>
          </Navbar.Brand>
          <Navbar.Brand href={baseUrl} aria-label='Zurück zur Startseite'>
            <FontAwesomeIcon icon='home' role='presentation' />{' '}
            {institutionLoaded ? institution.name : '?'}
            {programLoaded ? ` - ${program.name}` : '?'}
          </Navbar.Brand>
          {isTabletOrSmallDesktop && (
            <NavBadges
              program={program}
              dateExpired={dateExpired}
              dateFormatted={dateFormatted}
              isTabletOrSmallDesktop={isTabletOrSmallDesktop}
            />
          )}
          <Navbar.Toggle aria-controls='responsive-navbar-nav' />
          <Navbar.Collapse id='responsive-navbar-nav'>
            {!isTabletOrSmallDesktop && (
              <NavBadges
                program={program}
                dateExpired={dateExpired}
                dateFormatted={dateFormatted}
                isTabletOrSmallDesktop={isTabletOrSmallDesktop}
              />
            )}
            <Nav className='ml-auto'>
              <Nav.Link
                href={`${baseUrl}/hilfe`}
                className='text-white'
              >
                <FontAwesomeIcon icon='question-circle' role='presentation' />{' '}
                Hilfe
              </Nav.Link>
              {
                institution.show_pass_resend_form && (
                  <Nav.Link
                    href={`${baseUrl}/programm/veranstaltungspass`}
                    className="text-white"
                  >
                    <FontAwesomeIcon icon="address-card" role="presentation" />{' '}
                    Veranstaltungspass verloren?
                  </Nav.Link>
                )
              }
              <Nav.Link href={`${baseUrl}/admin/`} className='text-white'>
                <FontAwesomeIcon icon='sign-in-alt' role='presentation' />{' '}
                Verwaltung
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </>
    )
  }
}

export default MainNavbar
